module.exports={
    "over_size_message":"L'image que vous avez chargée dépasse 10M. Nous allons compresser votre fichier pour le téléchargement. Veuillez cliquer sur ”Confirmer“ pour continuer le téléchargement.",
    "file_type_error":"Le fichier que vous avez chargé n'est pas une image ! Veuillez réessayer de charger.",
    "upload_error":"Erreur de chargement ! (Code d'erreur : 2000) Veuillez réessayer.",
    "watermark_remove_over_size":"L'image que vous avez chargée dépasse 5M. Il est recommandé d'utiliser notre compresseur d'images en ligne gratuit. Cliquez pour <a class=\"jump-link\" href=\"https://www.tipard.com/fr/image-compressor-online/\">en savoir plus</a>",
    "watermark_remove_file_type_error":"Le fichier que vous avez chargé n'est pas une image, veuillez charger à nouveau.",
    "watermark_remove_image_type_error":"Le format d'image n'est pas pris en charge. Nous ne prenons en charge que JPG, JPEG, PNG et BMP. ",
    "watermark_remove_upload_error":"Erreur de reconnaissance (code erreur : 2001), veuillez réessayer...",
    "watermark_remove_processing":"Traitement de l'image...",
    "watermark_remove_not_save":"La zone que vous avez sélectionnée ne sera pas conservée. Êtes-vous sûr de vouloir le recadrer ?",
    "watermark_remove_back_home":"L'état actuel ne sera pas enregistré. Êtes-vous sûr de vouloir retourner à la page d'accueil ?",
    "watermark_remove_new_image":"L'état actuel ne sera pas enregistré. Voulez-vous vraiment choisir une nouvelle image ?",
    "watermark_select":"Sélectionner",
    "watermark_select_area":"Veuillez sélectionner la zone de filigrane que vous souhaitez effacer avant de cliquer sur Supprimer.",
    "watermark_beyond_4k":"L'image sélectionnée dépasse la résolution 4K. Nous sommes désolés de ne pas pouvoir le traiter pour le moment",
    "watermark_beyond_pixel_1":"La résolution d'image sélectionnée dépasse <span>%spx</span><span>&times;%spx</span>. Il ne peut pas être traité, veuillez sélectionner à nouveau.",
    "watermark_beyond_pixel_2":"Les visiteurs ne peuvent traiter que <span>%s</span> images avec une résolution supérieure à <span>%spx</span>x<span>%spx</span>, veuillez vous connecter et continuer à utiliser.",
    "watermark_beyond_size_1":"La taille de l'image sélectionnée dépasse <span>%sMO</span>. Il ne peut pas être traité, veuillez sélectionner à nouveau.",
    "watermark_beyond_size_2":"La taille de l'image sélectionnée dépasse <span>%sMO</span>, mais les visiteurs ne peuvent traiter que les images inférieures à <span>%sMO</span>. Veuillez vous connecter et continuer à utiliser.",
    "no_user_down":"Les visiteurs ne peuvent télécharger que <span>%s</span> images de qualité originale. Veuillez vous connecter et poursuivre le téléchargement. En outre, vous pouvez conserver l'historique de 7 jours après la connexion. Continuez à télécharger des images de <span>%spx</span> largeur ou hauteur.",
    "no_down_rights":"Impossible de télécharger des images HD avec la qualité d'origine, veuillez mettre à niveau votre forfait ! Vous pouvez également continuer à télécharger des images de mauvaise qualité avec <span>%spx</span>.",
    "error_40001":"Erreur : 40001. Veuillez nous contacter",
    "error_40099":"Erreur : 40099. Veuillez nous contacter",
    "down_btn":"Le téléchargement est en préparation, veuillez patienter une seconde…",
    "noRemove_down_btn":"Vous n'avez rien fait pour supprimer les filigranes. Veuillez sélectionner le filigrane que vous souhaitez supprimer et cliquez sur le bouton Supprimer. Ensuite, vous pouvez télécharger votre image.",
    "history_open":"Ouverture de l'image modifiée, veuillez patienter un instant...",
    "maskRightsMonitor_info":"La page de mise à niveau des avantages a été ouverte dans un nouvel onglet et votre plan sera automatiquement synchronisé après la mise à niveau.",
    "maskLoginMonitor_info":"La page d'accueil a été ouverte, veuillez vous y connecter. Après vous être connecté ou enregistré avec succès, cette page sera automatiquement synchronisée, veuillez ne pas la fermer.",
    "photo_rights_info":" <span><i class=\"num\">2</i> Image(s) HD</span> de qualité originale peuvent être téléchargées dès maintenant. <a href=\"https://account.tipard.com\" target=\"_blank\">Voir les détails>></a>",
    "rights_original":"Pour activer le paramètre \"Utiliser la fonction d'amélioration de l'image pour réduire la perte de qualité\", vous devez mettre à jour votre compte !",
    "Brush":"Brosser",
    "Lasso":"Lasso",
    "Polygonal":"Polygonal",
    "Eraser":"Gomme",
    "Free":"Libre",
    "More":"Plus:",
    "Select":"Sélectionner",
    "Remove":"Supprimer",
    "BrushSize":"Taille de la brosse:",
    "AspectRatio":"Ratio d'aspect:",
    "Upload":"Nouvelle photo",
    "History":"Historique",
    "Login":"Se Connecter",
    "MyAccount":"Mon compte",
    "Logout":"Se déconnecter",
    "Usinghelp":"Utiliser l'aide>>",
    "Enhancer":"Utiliser la fonction Image Enhancer pour réduire la perte de qualité",
    "Download":"Télécharger",
    "Guide":"Guide",
    "Polygonal1":"Polygonal:",
    "Polygonal_info":"Cliquez sur le bouton gauche de la souris pour identifier un point à la fois.",
    "Lasso1":"Lasso:",
    "Lasso_info":"Appuyez longuement sur le bouton gauche de la souris pour lasso la zone du filigrane.",
    "Brush1":"Brosser:",
    "Brush_info":"Appuyez longuement sur le bouton gauche de la souris pour sélectionner avec précision.",
    "Eraser1":"Gomme:",
    "Eraser_info":"Effacer les parties inutiles de la zone sélectionnée.",
    "Click":"Cliquer",
    "the":"le",
    "click_info":"bouton pour commencer à effacer le filigrane indésirable.",
    "PleaseUploadImages":"Veuillez télécharger des images.",
    "CropInfo":"Une fois la suppression du filigrane terminée, vous pouvez cliquer sur le bouton Rogner pour recadrer votre image avant de l'enregistrer, ou cliquer sur le bouton Télécharger pour enregistrer directement l'image actuelle.",
    "Crop":"Recadrer",
    "Back":"Retour",
    "DownloadCropped":"Télécharger recadrée",
    "Cancel":"Annuler",
    "FreeWatermarkRemover":"Free Watermark Remover",
    "Processing":"Traitement...",
    "NewImage":"Nouvelle image",
    "Retry":"Réessayer",
    "Yes":"Oui",
    "No":"Non",
    "FailureFeedback":"Feedback d'Erreur",
    "removeTip":"Après avoir sélectionné la zone du filigrane, veuillez cliquer sur Supprimer pour effacer le filigrane.",
    "rightDown":"Télécharger des images de basse qualité",
    "history_will":"Expire bientôt",
    "Expired":"(Expiré)",
	"uploadImage":"Ajouter une image",
    "uploadImageInfo":"Ou déposez votre fichier image ici pour supprimer le filigrane !",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain THREE HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"Illimité",
    "watermark_beyond_pixel_3":"L'image sélectionnée dépasse <span>%s&times;%s résolution</span>, veuillez d'abord mettre à niveau votre forfait.",
    "watermark_beyond_size_3":"L'image sélectionnée dépasse <span>%sMo</span>, veuillez d'abord mettre à niveau votre forfait.",
    "no_user_login":"Les nouveaux utilisateurs qui se connectent peuvent bénéficier de DEUX avantages de téléchargement d'images HD originales.<span class=\"loginMaskbtn\">Se Connecter immédiatement>></span>",
    "Upgrade":"Améliorer",
    "Loading":"Chargement…",
    "SelectAll":"Tout sélectionner",
    "Open":"Ouvrir",
    "Delete":"Supprimer",
    "Clear":"Effacer invalide",
    "noHistory":"Pas d'historique",
    "Close":"Fermer",
    "buyUserInfo":"Toutes nos félicitations! Vous avez mis à jour avec succès. Veuillez retourner à la page d'accueil et utiliser ce produit.",
    "buyNoUserInfo":"Toutes nos félicitations! Vous avez mis à jour avec succès. Les avantages sont liés à l'adresse e-mail que vous avez laissée lors de la mise à niveau. Veuillez utiliser le compte enregistré ou lié à l'adresse e-mail pour <span class=\"loginMaskbtn\">se connecter pour utiliser les avantages</span>. Si vous n'avez pas enregistré ou lié de compte avec l'adresse e-mail, veuillez <span class=\"registerMaskbtn\">utiliser l'adresse e-mail pour enregistrer un compte</span> ou lier d'autres comptes à cette adresse e-mail pour utiliser les avantages.",
    "GetStarted":"Commencer",
    "AccessTo":"Accès à:",
    "imagesOfwatermarkremoval":"images de suppression de filigrane",
    "upTo":"Jusqu'à",
    "perImage":"par image",
    "Support":"Support",
    "resolution":"résolution",
    "PrepaidPackage":"Forfait prépayé",
    "PayasYouGo":"Payé",
    "TaxIncl":"TVA incluse",
    "Checkout":"Vérifier",
    "imagesDay":"images/jour",
    "imagesMonthly":"images/mois",
    "image":"image",
    "images":"images",
    "imageSize":"taille de l'image",
    "buyInfo1":"Intégrations d'<span>amplificateurs</span> tiers",
    "buyInfo2":"L'historique d'édition est valable 7 jours",
    "buyInfo3":"Traitement prioritaire",
    "buyInfo4":"Assistance client 7x24",
    "buyInfo5":"Expiré après 24 heures",
    "buyInfo6":"Pas d'abonnement. Pas de renouvellement automatique !",
    "buyInfo7":"Disponible pour une utilisation à tout moment pour toujours",
    "dayPlan":"Forfait 1 Jour",
    "Lifetime":"À Vie",
    "note":"Remarque : veuillez noter que le forfait acheté est lié à l'adresse e-mail fournie lors du paiement. Pour utiliser le forfait avec succès, inscrivez-vous ou connectez-vous avec cette même adresse e-mail.",
    "buy_now": "Acheter maintenant",
    
    "banner_title": "Cleanup photo AI - combien de crédits vous voulez",
    "banner_info": "1 crédit = 1 Image: Vous coûtez 1 crédit pour traiter et enregistrer une image supérieure à 600 × 600 pixels. ",
    "monthlyPlan_title": "Plan mensuel",
    "monthlyPlan_displayPricePerCredit": "/crédit",
    "monthlyPlan_plan1_credits": "crédits / mois",
    "monthlyPlan_feature1": "<Span> sans risque: </span> Garantie de remboursement de 30 jours",
    "monthlyPlan_feature2": "<span> automatique: </span> Les crédits sont renouvelés automatiquement",
    "monthlyPlan_feature3": "<Span> Flexible: </span> Détrracener, mettre à niveau ou annuler à tout moment",
    "oneTimePurchase_title": "Achat unique",
    "oneTimePurchase_plan5_credits": "crédits / vie",
    "oneTimePurchase_feature1": "Garantie de remboursement de 30 jours",
    "oneTimePurchase_feature2": "Valable en permanence après l'achat",
    "payment_title": "Vous pouvez choisir plusieurs méthodes de paiement",
    "payment_image_alt": "Méthodes de paiement",
    "faq_title": "Des questions fréquemment posées sur l'achat des crédits",
    "faq_question1_title": "Que sont les crédits?",
    "faq_question1_info": "Notre service est mesuré dans l'unité de crédits. ",
    "faq_question2_title": "Dois-je choisir un abonnement mensuel ou un achat unique?",
    "faq_question2_info": "Pour les tâches d'image irrégulières ou une exigence d'utilisation peu fréquente, vous pouvez choisir un achat unique, où vous pouvez acheter le montant approprié des crédits en fonction de vos besoins en image. ",
    "faq_question3_title": "Et si j'utilise mes crédits?",
    "faq_question3_info": "Vous pouvez mettre à niveau votre abonnement ou continuer à acheter un plan d'achat unique en fonction de vos besoins de traitement des photos. ",
    "faq_question4_title": "Puis-je mettre à niveau, rétrograder ou annuler mon abonnement?",
    "faq_question4_info": "Oui, vous pouvez. ",
    "whyChoose_title": "Pourquoi choisir Tipard",
    "whyChoose_reason1_title": "Téléchargement sécurisé",
    "whyChoose_reason1_info": "Les programmes de Tipard sont 100% propres et sûrs",
    "whyChoose_reason2_title": "Technologie professionnelle",
    "whyChoose_reason2_info": "L'équipe qualifiée fournit des produits professionnels",
    "whyChoose_reason3_title": "Support client 24/7",
    "whyChoose_reason3_info": "Services de consultants aux patients tout le temps",
    "whyChoose_reason4_title": "30 jours en arrière",
    "whyChoose_reason4_info": "Garantir le remboursement aux utilisateurs dans 30 jours",
    "whyChoose_reason5_title": "Plus de 1 000 000 utilisateurs",
    "whyChoose_reason5_info": "Utilisé et fait confiance par plus d'un million de personnes",
    "whyChoose_reason6_title": "160+ pays",
    "whyChoose_reason6_info": "Vendu dans plus de 160 pays et régions"
}